import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { FiArrowLeft, FiSave } from "react-icons/fi";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import { makeRequestAuth } from "../../_config/api";

function CreateAppSetting() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    key: "",
    value: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) return showErrorToast("Name is required");

    try {
      setSubmitting(true);
      const response = await makeRequestAuth(
        "post",
        "/appSetting/createAppSetting",
        formData,
      );

      if (
        response.status === true ||
        response.success === true ||
        response.data
      ) {
        showSuccessToast("App setting created successfully!");
        setTimeout(() => navigate("/app-settings"), 1500);
      } else {
        showErrorToast(response.message || "Failed to create setting");
      }
    } catch (err) {
      console.error("Error creating setting:", err);
      showErrorToast(
        err.response?.data?.message || err.message || "Server error",
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="p-4">
      <div className="bg-white dark:bg-[#1E2738] rounded-2xl p-6 md:p-8 border border-purple-300 dark:border-purple-600/50 shadow-xl">
        {/* Header */}
        <div className="flex justify-between items-center mb-8 border-b border-gray-200 dark:border-gray-700 pb-4">
          <div>
            <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              Add New Setting
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              Create a new core application configuration.
            </p>
          </div>
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-gray-500 hover:text-purple-600 transition"
          >
            <FiArrowLeft size={20} /> Back
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="e.g. Platform Fee"
              className="w-full px-4 py-3 rounded-xl border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700/50 text-gray-800 dark:text-white focus:ring-2 focus:ring-purple-500 outline-none transition"
              required
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Key
            </label>
            <input
              type="text"
              name="key"
              value={formData.key}
              onChange={handleChange}
              placeholder="e.g. PLATFORM_FEE_PERCENT"
              className="w-full px-4 py-3 rounded-xl border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700/50 text-gray-800 dark:text-white focus:ring-2 focus:ring-purple-500 outline-none transition font-mono"
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Value
            </label>
            <textarea
              name="value"
              rows={4}
              value={formData.value}
              onChange={handleChange}
              placeholder="e.g. 2.5"
              className="w-full px-4 py-3 rounded-xl border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700/50 text-gray-800 dark:text-white focus:ring-2 focus:ring-purple-500 outline-none transition"
            />
          </div>

          {/* Submit Actions */}
          <div className="flex justify-end gap-4 pt-4 border-t border-gray-200 dark:border-gray-700">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="px-6 py-2.5 rounded-xl border border-gray-300 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="flex items-center gap-2 px-8 py-2.5 rounded-xl bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold shadow-lg hover:scale-[1.02] transition disabled:opacity-50"
            >
              {submitting ? (
                "Saving..."
              ) : (
                <>
                  <FiSave /> Save Setting
                </>
              )}
            </button>
          </div>
        </form>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default CreateAppSetting;
